import path from 'path-browserify';
import store from '@/store';
// import { getCurrentInstance } from 'vue'
import axios from 'axios';

// 深拷贝
export function deepClone(target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]));
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}

// 防抖
export const debounce = (fn, delay = 300, immediate = true) => {
    let timer = null; // 借助闭包
    return function () {
        if (timer) {
            clearTimeout(timer);
        }
        if (immediate) {
            let callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, delay);
            if (callNow) {
                fn.apply(this, arguments);
            }
        } else {
            timer = setTimeout(() => {
                fn.apply(this, arguments);
            }, delay);
        }
    };
};

// 节流
export function throttle(fn, delay = 300) {
    let valid = true;
    return function () {
        if (!valid) {
            return false;
        }
        // 工作时间，执行函数并且在间隔期内把状态位设为无效
        valid = false;
        setTimeout(() => {
            fn.apply(this, arguments);
            valid = true;
        }, delay);
    };
}

function hasPermission(permission) {
    if (store.state.settings.enablePermission) {
        return store.state.user.permissions.some((v) => {
            return v === permission;
        });
    } else {
        return true;
    }
}

export async function auth(value) {
    let auth;
    if (typeof value === 'string') {
        auth = await hasPermission(value);
    } else {
        auth = await value.some(async (item) => {
            return await hasPermission(item);
        });
    }
    return auth;
}

export function authAll(value) {
    const auth = value.every((item) => {
        return hasPermission(item);
    });
    return auth;
}

export function isExternalLink(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}

export function resolveRoutePath(basePath, routePath) {
    if (isExternalLink(routePath)) {
        return routePath;
    }
    if (isExternalLink(basePath)) {
        return basePath;
    }
    return basePath ? path.resolve(basePath, routePath) : routePath;
}
// 脱敏
export function maskPhone (phone) {
    if (!phone) return '-';
    const str = String(phone);
    if (str.length <= 7) return str;
    return str.slice(0, 3) + '****' + str.slice(-4);
}

// 数字加千分位符号
export function formatToTho(num) {
    var res = num.toString().replace(/\d+/, function (n) {
        // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
            return $1 + ',';
        });
    });
    return res;
}
// 金额格式化：添加千位分隔符并保留两位小数
export function formatToCurrency(value) {
    if (value === null || value === undefined || value === '') return '0.00';
    // 去掉已有逗号，尝试转为数字
    const num = Number(String(value).replace(/,/g, ''));
    if (isNaN(num)) return '0.00';

    const negative = num < 0;
    const abs = Math.abs(num);
    // 保留两位小数（四舍五入）
    const fixed = abs.toFixed(2);
    const parts = fixed.split('.');
    const intPart = parts[0];
    const decPart = parts[1];
    // 整数部分每三位加逗号
    const intWithCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (negative ? '-' : '') + intWithCommas + '.' + decPart;
}
// 数字转中文
export function amountLtoU(amount) {
    // 数值最大不超过1万亿
    if (isNaN(amount) || amount >= 1000000000000) return '无效金额！';
    // 将负号‘-’显示成汉字‘(负)’
    let sPrefix = amount < 0 ? '(负)' : '';
    // 当传入的金额没有经过科学计算保留两位小数的话，则用四舍五入进行处理
    amount = Math.round(amount * 100) / 100;
    // 格式化成两位小数格式（两位小数对应“'角”和“分”）
    let sAmount = Math.abs(amount).toFixed(2);
    // 14个数字单位，1万亿以内的数位按顺序从左到右对应排列
    let sUnit = [
        '仟',
        '佰',
        '拾',
        '亿',
        '仟',
        '佰',
        '拾',
        '万',
        '仟',
        '佰',
        '拾',
        '元',
        '角',
        '分',
    ];
    // 10个大写数字，以数字为索引取对应的大写（eg: sCapital[8] -> ‘捌’）
    let sCapital = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    // 去除小数点（使数字与数位对应）
    sAmount = sAmount.replace('.', '');
    // 截取当前传入金额对应的数位集合
    sUnit.splice(0, sUnit.length - sAmount.length);
    let sOutput = '';
    for (let i = 0, len = sAmount.length; i < len; i++) {
        // 拼接大写数字与数位
        sOutput += sCapital[Number(sAmount.slice(i, i + 1))] + sUnit[i];
    }
    // 返回的时候用正则过滤掉零千、零百、零万等情况
    return (
        sPrefix +
        sOutput
            .replace(/零角零分$/, '整')
            .replace(/零[仟佰拾]/g, '零')
            .replace(/零{2,}/g, '零')
            .replace(/零([亿|万])/g, '$1')
            .replace(/零+元/, '元')
            .replace(/亿零{0,3}万/, '亿')
            .replace(/^元/, '零元')
    );
}

// 文件下载(row：当前行数据，url：接口地址，docType：下载文档类型)
export function onFileDownload(row, url, docType, proxy) {
    if (row.name.substring(row.name.lastIndexOf('.') + 1) !== docType) {
        row.name = `${row.name}.${docType}`;
    }
    axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: { Token: store.state.user.platform_token },
    }).then(function (res) {
        const resData = res.data;
        if (resData.type === 'application/json') {
            // 说明是普通对象数据，读取信息
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
                const jsonData = JSON.parse(fileReader.result);
                // 后台信息
                if (jsonData.code === 'A0400' && jsonData.data === null) {
                    proxy.$message.error(jsonData.msg);
                }
            };
            fileReader.readAsText(resData);
        } else {
            // 为blob设置文件类型
            let blob = new Blob([res.data]);
            // 创建一个临时的url指向blob对象
            let url = window.URL.createObjectURL(blob);
            // 创建一个a标签，用来下载
            let a = document.createElement('a');
            a.href = url;
            a.download = row.name;
            a.click();
            // 释放这个临时的对象url
            window.URL.revokeObjectURL(url);
        }
    });
}
// 文件下载
export function onDownloadFile(url, proxy) {
    axios({
        method: 'get',
        url: url,
        responseType: 'blob',
        headers: { Token: localStorage.getItem('fa_platform_token') },
    })
        .then(function (res) {
            const resData = res.data;
            if (resData.type === 'application/json') {
                // 说明是普通对象数据，读取信息
                const fileReader = new FileReader();
                fileReader.onloadend = () => {
                    const jsonData = JSON.parse(fileReader.result);
                    // 后台信息
                    if (jsonData.code === 'A0400' && jsonData.data === null) {
                        proxy.$message.error(jsonData.msg);
                    }
                };
                fileReader.readAsText(resData);
            } else {
                // 为blob设置文件类型
                let blob = new Blob([res.data]);
                // 创建一个临时的url指向blob对象
                let url = window.URL.createObjectURL(blob);
                // 创建一个a标签，用来下载
                let a = document.createElement('a');
                a.href = url;
                // 获取特定的响应头
                let contentDisposition = res.headers['content-disposition'];
                let strArr = contentDisposition.split('filename=');
                // 解码URL
                let filename = decodeURIComponent(strArr[1]);
                a.download = filename;
                a.click();
                // 释放这个临时的对象url
                window.URL.revokeObjectURL(url);
            }
        })
        .catch((err) => {
            proxy.$message.error(err.msg);
        });
}
export function newDate(time) {
    let date = new Date(time);
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? `0${m}` : m;
    let d = date.getDate();
    d = d < 10 ? `0${d}` : d;
    return `${y}-${m}-${d}`;
}
